import DocumentPreview from 'views/customer/profile/documents/DocumentPreview';
import { mockDeliveryCertificate, mockTaxInvoice, mockReceipt, mockInvoice, mockDebt, mockVisitNote } from './mocks';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useState } from 'react';

const MobileDeliveryCertificate = () => {
    const [selectedDocument, setSelectedDocument] = useState(mockDeliveryCertificate);

    // return (
    //     <Box>
    //         <Button variant="contained" onClick={() => setSelectedDocument(mockDeliveryCertificate)}>
    //             Delivery Certificate
    //         </Button>
    //         <Button variant="contained" onClick={() => setSelectedDocument(mockTaxInvoice)}>
    //             Tax Invoice
    //         </Button>
    //         <Button variant="contained" onClick={() => setSelectedDocument(mockReceipt)}>
    //             Receipt
    //         </Button>
    //         <Button variant="contained" onClick={() => setSelectedDocument(mockInvoice)}>
    //             Invoice
    //         </Button>
    //         <Button variant="contained" onClick={() => setSelectedDocument(mockDebt)}>
    //             Debt
    //         </Button>
    //         <Button variant="contained" onClick={() => setSelectedDocument(mockVisitNote)}>
    //             Visit Note
    //         </Button>

    //         <DocumentPreview document={selectedDocument} outerDoc={undefined} creditRecepitValue={false} setCreditRecepitValue={() => {}} />
    //     </Box>
    // );

    return <DocumentPreview document={selectedDocument} outerDoc={undefined} creditRecepitValue={false} setCreditRecepitValue={() => {}} />;
};

export default MobileDeliveryCertificate;
